import axios from "shared/api/axiosConfig";
import { encryptApiBodyFromJSON, encryptApiBodyFromString } from "shared/api/cryptApiBody";

export async function invitation(email,type) {
	const body = new FormData();
	body.append("email",encryptApiBodyFromString(email))
	body.append("type",type)
	const response = await axios.post("/client/email/invitation",body);
	
	return response;


}
export async function shareFile(email,file,type) {
	const body = new FormData();
	body.append("email",encryptApiBodyFromString(email))
	body.append("file",file)
	body.append("type",type)
	const response = await axios.post("client/email/invitation/file",body);
	return response;
}

export async function documentRequest(documentId,type, uid = "") {
	const response = await axios.post("/client/documentrequests",{
		documentId, // numero du doc: string
		type,
		uid
	});
	return response;
}

export async function documentConfirm(requestId, status) {
	const body = new FormData();
	body.append("requestId",requestId)
	body.append("status",status)
	const response = await axios.post("/client/documentrequests/confirm",body);
	return response;
}

export async function documentRequestResponse(id,type) {
	const response = await axios.post("/client/documentrequests/handshake",{ id,type });
	return response;
}
